module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dialog-delete-location/dialog-confirmation.component.scss
// module id = ./src/app/shared/dialog-delete-location/dialog-confirmation.component.scss
// module chunks = main